import { Injectable } from '@angular/core';

import { LOCAL_STORAGE_KEY } from '../../common/constants';

interface CalendarPreferences {
  view: string;
  type: string;
}

export interface DashboardPreferences {
  attentionCollapsed: boolean;
  upcomingExpirationsCollapsed: boolean;
  upcomingRenewalsCollapsed: boolean;
}

export const defaults = {
  calendar: {
    type: 'all',
    view: 'day',
  },
  dashboard: {
    attentionCollapsed: false,
    upcomingExpirationsCollapsed: false,
    upcomingRenewalsCollapsed: false,
  },
};

@Injectable()
export class AppPreferenceService {
  constructor() {}

  getPreferencesForKey(key: string): any {
    const value = JSON.parse(localStorage.getItem(key));

    return value || null;
  }

  setPreferencesForKey(key: string, payload: any): void {
    const value = typeof payload === 'object' ? JSON.stringify(payload) : payload;

    localStorage.setItem(key, value);
  }

  getCalendarPreferences(): CalendarPreferences {
    const localStorageValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.PREFERENCES.CALENDAR));

    return {
      ...defaults.calendar,
      ...localStorageValue,
    };
  }

  setCalendarPreferences(preferences: CalendarPreferences): void {
    const value = JSON.stringify({
      ...defaults.calendar,
      ...preferences,
    });

    return localStorage.setItem(LOCAL_STORAGE_KEY.PREFERENCES.CALENDAR, value);
  }

  getDashboardPreferences(): DashboardPreferences {
    const localStorageValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.PREFERENCES.DASHBOARD));

    return {
      ...defaults.dashboard,
      ...localStorageValue,
    };
  }

  setDashboardPreferences(preferences: DashboardPreferences): void {
    const value = JSON.stringify({
      ...defaults.dashboard,
      ...preferences,
    });

    return localStorage.setItem(LOCAL_STORAGE_KEY.PREFERENCES.DASHBOARD, value);
  }
}
